import { render, staticRenderFns } from "./catalog.vue?vue&type=template&id=551d4d52&scoped=true&"
import script from "./catalog.ts?vue&type=script&lang=ts&"
export * from "./catalog.ts?vue&type=script&lang=ts&"
import style0 from "./catalog.scss?vue&type=style&index=0&id=551d4d52&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "551d4d52",
  null
  
)

export default component.exports